/**
 * Реклама поверх игры. Пока она на экране и ещё немного после закрытия, MainView не
 * перестраивает сцену под новый размер окна: на мобиле реклама Яндекса сама двигает вьюпорт
 * айфрейма и после закрытия обычно возвращает его обратно, а перестроение посреди показа
 * сносит открытые панели - вместе с ними пропадала и панель награды за просмотр.
 */
export default class AdvOverlay {

    /** После закрытия размер ещё доезжает обратно - столько ждём, прежде чем перестраиваться. */
    private static readonly AFTER_CLOSE_MS: number = 2000;

    /** Страховка, если SDK не позовёт ни onClose, ни onError или упадёт на самом вызове. */
    private static readonly MAX_SHOW_MS: number = 3 * 60 * 1000;

    private static openedAt: number = 0;
    private static closedAt: number = 0;

    public static opened(): void {
        AdvOverlay.openedAt = Date.now();
    }

    public static closed(): void {
        AdvOverlay.closedAt = Date.now();
    }

    public static isActive(): boolean {
        const now = Date.now();
        if (AdvOverlay.openedAt > AdvOverlay.closedAt) {
            return now - AdvOverlay.openedAt < AdvOverlay.MAX_SHOW_MS;
        }
        return now - AdvOverlay.closedAt < AdvOverlay.AFTER_CLOSE_MS;
    }
}
